import styled from '@emotion/styled';
import { Field } from 'formik';
import { Variables } from '../base/variables/variables';

export const DialogBody = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-height: min(80vh, 720px);
    overflow: hidden;
`;

export const DialogScrollArea = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 0 24px 16px;
`;

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
`;

export const Label = styled.span`
    font-size: 16px;
    font-weight: 500;
    color: ${Variables.Colors.n70};
`;

export const Description = styled.span`
    font-size: 14px;
    color: ${Variables.Colors.n50};
`;

export const Info = styled.div`
    font-size: 13px;
    color: ${Variables.Colors.n50};
    line-height: 1.4;
    background: ${Variables.Colors.n5};
    border-radius: 4px;
    padding: 8px 12px;
`;

export const FormField = styled(Field)`
    width: 100%;
    display: block;
`;

export const Actions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    flex-shrink: 0;
    padding: 16px 24px 24px;
    border-top: 1px solid ${Variables.Colors.n5};
    background: ${Variables.Colors.white};
`;

export const ErrorMessage = styled.span`
    font-size: 13px;
    color: ${Variables.Colors.warning};
`;
